import React, {useLayoutEffect, useState} from 'react';
import clsx from 'clsx';

import Loader from './components/loader';
import {fetchData, getCountryIconUrl, sortPositionCountries} from './utils/helpers';

import styles from './medal-table.module.css';

const KAZ_CODE = 'kz';

const MedalTable = ({
  mockData = null,
  apiUrl,
  medalTableItemClassName,
  countryPositionClassName,
  countryNameClassName,
  highlightedMedalTableItemClassName,
  medalsBlockWrapClassName,
  totalMedalClassName,
  emptyBlockClassName,
  medalClassName,
  countryInfoBlockClassName
}) => {
  const [data, setData] = useState({
    countries: mockData,
    isLoading: false
  });

  useLayoutEffect(() => {
    const fetchDataItems = async () => {
      if (mockData?.length || !apiUrl) {
        return;
      }

      setData(prevState => ({
        ...prevState,
        isLoading: true
      }));

      try {
        const response = await fetchData({domain: window.Site?.sportDomain, url: apiUrl});

        setData({
          isLoading: false,
          countries: sortPositionCountries(response)
        });
      } catch (e) {
        console.error(e);
        setData(prevState => ({
          ...prevState,
          isLoading: false
        }));
      }
    };

    fetchDataItems();
  }, [mockData]);

  if (data.isLoading) {
    return <Loader color='#fff' />;
  }

  if (!data.countries?.length) {
    return (
      <div className={clsx(styles.emptyBlock, styles.medalTableBlock, emptyBlockClassName)}>
        <p className={styles.emptyBlockText}>
          На данный момент еще ни одна страна не получила медаль
        </p>
      </div>
    );
  }

  return (
    <div className={styles.medalTable}>
      {data.countries.map(country => {
        const countryCode = country.code.toLowerCase();

        return (
          <div
            key={countryCode}
            className={clsx(styles.medalTableItem, styles.medalTableBlock, medalTableItemClassName, {
              [styles.highlightedMedalTableItem]: countryCode === KAZ_CODE,
              [highlightedMedalTableItemClassName]: countryCode === KAZ_CODE
            })}
          >
            <div className={clsx(styles.countryInfoBlock, countryInfoBlockClassName)}>
              {
                country.position && (
                  <p className={clsx(styles.countryPosition, countryPositionClassName)}>
                    {country.position}
                  </p>
                )
              }
              <img
                className={styles.countryIcon}
                src={getCountryIconUrl(countryCode)}
                loading='lazy'
                alt={`Country ${countryCode}`}
              />
              <p className={clsx(styles.countryName, countryNameClassName)}>{country.name}</p>
            </div>
            <div className={styles.medalsBlock}>
              <div className={clsx(styles.medalsBlockWrap, medalsBlockWrapClassName)}>
                <span className={clsx(styles.medal, styles.goldMedal, medalClassName)}>{country.medals.gold}</span>
                <span className={clsx(styles.medal, styles.silverMedal, medalClassName)}>
                  {country.medals.silver}
                </span>
                <span className={clsx(styles.medal, styles.bronzeMedal, medalClassName)}>
                  {country.medals.bronze}
                </span>
              </div>
              <p className={clsx(styles.totalMedal, totalMedalClassName)}>
                Всего: <span className={styles.totalMedalCount}>{country.medals.total}</span>
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MedalTable;
